/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendMaterialDto } from '../models/backend-material-dto';
import { opexesMaterialsCopyCreate } from '../fn/opexs-materials/opexes-materials-copy-create';
import { OpexesMaterialsCopyCreate$Params } from '../fn/opexs-materials/opexes-materials-copy-create';
import { opexesMaterialsCreate } from '../fn/opexs-materials/opexes-materials-create';
import { opexesMaterialsCreate$FormData } from '../fn/opexs-materials/opexes-materials-create-form-data';
import { OpexesMaterialsCreate$FormData$Params } from '../fn/opexs-materials/opexes-materials-create-form-data';
import { OpexesMaterialsCreate$Params } from '../fn/opexs-materials/opexes-materials-create';
import { opexesMaterialsCreate$XWwwFormUrlencoded } from '../fn/opexs-materials/opexes-materials-create-x-www-form-urlencoded';
import { OpexesMaterialsCreate$XWwwFormUrlencoded$Params } from '../fn/opexs-materials/opexes-materials-create-x-www-form-urlencoded';
import { opexesMaterialsDestroy } from '../fn/opexs-materials/opexes-materials-destroy';
import { OpexesMaterialsDestroy$Params } from '../fn/opexs-materials/opexes-materials-destroy';
import { opexesMaterialsEnumsRetrieve } from '../fn/opexs-materials/opexes-materials-enums-retrieve';
import { OpexesMaterialsEnumsRetrieve$Params } from '../fn/opexs-materials/opexes-materials-enums-retrieve';
import { opexesMaterialsList } from '../fn/opexs-materials/opexes-materials-list';
import { OpexesMaterialsList$Params } from '../fn/opexs-materials/opexes-materials-list';
import { opexesMaterialsPartialUpdate } from '../fn/opexs-materials/opexes-materials-partial-update';
import { opexesMaterialsPartialUpdate$FormData } from '../fn/opexs-materials/opexes-materials-partial-update-form-data';
import { OpexesMaterialsPartialUpdate$FormData$Params } from '../fn/opexs-materials/opexes-materials-partial-update-form-data';
import { OpexesMaterialsPartialUpdate$Params } from '../fn/opexs-materials/opexes-materials-partial-update';
import { opexesMaterialsPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs-materials/opexes-materials-partial-update-x-www-form-urlencoded';
import { OpexesMaterialsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-materials/opexes-materials-partial-update-x-www-form-urlencoded';
import { opexesMaterialsRetrieve } from '../fn/opexs-materials/opexes-materials-retrieve';
import { OpexesMaterialsRetrieve$Params } from '../fn/opexs-materials/opexes-materials-retrieve';
import { opexesMaterialsUpdate } from '../fn/opexs-materials/opexes-materials-update';
import { opexesMaterialsUpdate$FormData } from '../fn/opexs-materials/opexes-materials-update-form-data';
import { OpexesMaterialsUpdate$FormData$Params } from '../fn/opexs-materials/opexes-materials-update-form-data';
import { OpexesMaterialsUpdate$Params } from '../fn/opexs-materials/opexes-materials-update';
import { opexesMaterialsUpdate$XWwwFormUrlencoded } from '../fn/opexs-materials/opexes-materials-update-x-www-form-urlencoded';
import { OpexesMaterialsUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-materials/opexes-materials-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsMaterialsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `opexesMaterialsList()` */
  static readonly OpexesMaterialsListPath = '/api/opexes/materials/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsList$Response(
    params?: OpexesMaterialsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMaterialDto>>> {
    return opexesMaterialsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsList(
    params?: OpexesMaterialsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMaterialDto>> {
    return this.opexesMaterialsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMaterialDto>>): Array<BackendMaterialDto> => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsCreate()` */
  static readonly OpexesMaterialsCreatePath = '/api/opexes/materials/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesMaterialsCreate$Response(
    params: OpexesMaterialsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesMaterialsCreate(params: OpexesMaterialsCreate$Params, context?: HttpContext): Observable<BackendMaterialDto> {
    return this.opexesMaterialsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesMaterialsCreate$XWwwFormUrlencoded$Response(
    params: OpexesMaterialsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesMaterialsCreate$XWwwFormUrlencoded(
    params: OpexesMaterialsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesMaterialsCreate$FormData$Response(
    params: OpexesMaterialsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesMaterialsCreate$FormData(
    params: OpexesMaterialsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsRetrieve()` */
  static readonly OpexesMaterialsRetrievePath = '/api/opexes/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsRetrieve$Response(
    params: OpexesMaterialsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsRetrieve(
    params: OpexesMaterialsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsUpdate()` */
  static readonly OpexesMaterialsUpdatePath = '/api/opexes/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesMaterialsUpdate$Response(
    params: OpexesMaterialsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesMaterialsUpdate(params: OpexesMaterialsUpdate$Params, context?: HttpContext): Observable<BackendMaterialDto> {
    return this.opexesMaterialsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesMaterialsUpdate$XWwwFormUrlencoded$Response(
    params: OpexesMaterialsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesMaterialsUpdate$XWwwFormUrlencoded(
    params: OpexesMaterialsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesMaterialsUpdate$FormData$Response(
    params: OpexesMaterialsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesMaterialsUpdate$FormData(
    params: OpexesMaterialsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsDestroy()` */
  static readonly OpexesMaterialsDestroyPath = '/api/opexes/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsDestroy$Response(
    params: OpexesMaterialsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesMaterialsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsDestroy(params: OpexesMaterialsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.opexesMaterialsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsPartialUpdate()` */
  static readonly OpexesMaterialsPartialUpdatePath = '/api/opexes/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesMaterialsPartialUpdate$Response(
    params: OpexesMaterialsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesMaterialsPartialUpdate(
    params: OpexesMaterialsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesMaterialsPartialUpdate$XWwwFormUrlencoded$Response(
    params: OpexesMaterialsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesMaterialsPartialUpdate$XWwwFormUrlencoded(
    params: OpexesMaterialsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesMaterialsPartialUpdate$FormData$Response(
    params: OpexesMaterialsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesMaterialsPartialUpdate$FormData(
    params: OpexesMaterialsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsCopyCreate()` */
  static readonly OpexesMaterialsCopyCreatePath = '/api/opexes/materials/{id}/copy/';

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsCopyCreate$Response(
    params: OpexesMaterialsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMaterialDto>> {
    return opexesMaterialsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsCopyCreate(
    params: OpexesMaterialsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendMaterialDto> {
    return this.opexesMaterialsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMaterialDto>): BackendMaterialDto => r.body),
    );
  }

  /** Path part for operation `opexesMaterialsEnumsRetrieve()` */
  static readonly OpexesMaterialsEnumsRetrievePath = '/api/opexes/materials/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesMaterialsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsEnumsRetrieve$Response(
    params: OpexesMaterialsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesMaterialsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesMaterialsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesMaterialsEnumsRetrieve(params: OpexesMaterialsEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.opexesMaterialsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
